import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';

import { getProduto, Produto } from 'config/produto-env';

import { sanitizarEvento } from './sanitizar';

const URL_COLETOR = 'https://rum.funifier.com/collect';

const NOME_DO_APP: Record<Produto, string> = {
  PREMIO_BB: 'premio-bb',
  PREMIO_ELBB: 'premio-elbb',
};

/**
 * Só inicia em build de produção: o .env.local também é lido pelo npm start,
 * e o coletor não aceita localhost. O console fica fora do envio porque há
 * logs com dados pessoais; exceções continuam sendo capturadas.
 */
export function iniciarFaro(): void {
  const apiKey = process.env.REACT_APP_FARO_API_KEY;
  if (process.env.NODE_ENV !== 'production' || !apiKey) return;

  try {
    initializeFaro({
      url: URL_COLETOR,
      apiKey,
      app: {
        name: NOME_DO_APP[getProduto()],
        version: process.env.REACT_APP_VERSION || 'unknown',
        environment: process.env.REACT_APP_ENVIRONMENT || 'development',
      },
      instrumentations: getWebInstrumentations({ captureConsole: false }),
      beforeSend: sanitizarEvento,
    });
  } catch {
    // A observabilidade nunca pode impedir o site de abrir.
  }
}
